import { tags } from '@lezer/highlight';

import type { SyntaxHighlightingOverrides } from './CodeEditorAdvanced/types';

interface SyntaxHighlightingOverride {
  tag: keyof typeof tags;
  color: string;
}

export const getSyntaxHighlightingOverrides = (overrides: readonly SyntaxHighlightingOverride[]) =>
  overrides.map(({ tag, color }) => ({
    tag: tags[tag],
    color,
  })) as SyntaxHighlightingOverrides;
